import React from 'react';
import { CSS_VARIABLE_STAGE_VISIBLE_SCALE } from '../../../../constants/stage-css-variables';
import type { NodeT, SkeletonPreviewStyleT } from '../../../../types';
import { SKELETON_PREVIEW_STYLE } from '../constants';
type PropsT = {
  nodes: NodeT[];
  style: SkeletonPreviewStyleT;
};
const nodeStyle: React.CSSProperties = {
  transformOrigin: '50% 50%',
  transformBox: 'fill-box',
  transform: `scale(var(${CSS_VARIABLE_STAGE_VISIBLE_SCALE}, 1))`
};
export const PreviewNodes = ({
  nodes,
  style
}: PropsT) => <>
    {nodes.map(node => <circle key={`preview-node-${node.id}`} cx={node.point[0]} cy={node.point[1]} r={SKELETON_PREVIEW_STYLE.NODE_RADIUS} fill={node.color ?? style.strokeColor} stroke={SKELETON_PREVIEW_STYLE.NODE_STROKE_COLOR} strokeWidth={SKELETON_PREVIEW_STYLE.NODE_STROKE_WIDTH} opacity={SKELETON_PREVIEW_STYLE.NODE_OPACITY} style={nodeStyle} />)}
  </>;